import React from 'react';
import {
    HeaderGridContainer,
    HeaderTextContainer,
    GridContainer,
    ItemCardTextContainer,
    DeleteBtnDiv,
    BatchNum,
    BatchNumDiv,
    SetNum,
    BarCode,
    SetDesc,
    CurrentLoc,
    AccountName,
    MobileSetsDiv,
} from './index.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import DeleteDarkIcon from 'src/assets/images/DeleteDarkIcon.svg';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import {
    deleteAllSets,
    resetCreateReceiveSets,
    resetTerritoryReceiveSets,
    saveReceiveSetsDetails,
    saveSetsOutsideTerritoryList,
    setBarcodeDetails,
    setProductDetails,
} from 'src/pages/receiveSets/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { BoxView } from 'src/pages/reportUsage/common/Common.styled.jsx';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { useTranslation } from 'react-i18next';

export default function MobileSetsList({
    setsList,
    setListArr,
    counterMessage,
    setCounterMessage,
}) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const setsOutsideTerritoryList = useSelector(
        (state) => state.receiveSetsListDataReducer.setsOutsideTerritoryList
    );
    const handleDeleteAll = () => {
        setCounterMessage(0);
        dispatch(deleteAllSets([]));
        dispatch(setBarcodeDetails());
        dispatch(setProductDetails());
        dispatch(resetCreateReceiveSets([]));
        dispatch(resetTerritoryReceiveSets([]));
    };
    const handleIndividualItemDelete = (index) => {
        const updatedSetsOutsideTerritoryList = setsOutsideTerritoryList.filter(
            (item) => item.barcode !== setsList[index].barcode
        );

        dispatch(saveSetsOutsideTerritoryList(updatedSetsOutsideTerritoryList));

        if (setsList[index]) {
            if (setsList[index].isFromBarcode) {
                setCounterMessage(counterMessage - 1);
            }
            setsList.splice(index, 1);
        }
        setListArr(setsList);
        dispatch(saveReceiveSetsDetails(setsList));
    };
    return (
        <MobileSetsDiv>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    mobile={6}
                >
                    {t('receiveSets.ReceiveSetsLoc.MobileSetsList.setsBatch')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    mobile={6}
                    style={{ textAlign: 'right' }}
                >
                    <DeleteBtnDiv>
                        <div
                         id="receivesets-mobilesetslist-deleteall-text"
                            onClick={handleDeleteAll}
                            style={{
                                marginRight: '8px',
                                color: '#1010EB',
                                cursor: 'pointer',
                            }}
                        >
                            {t('receiveSets.ReceiveSetsLoc.MobileSetsList.deleteAll')}
                        </div>
                        <div>
                            <img
                            id="receivesets-mobilesetslist-deleteall-icon"
                                src={DeleteDarkIcon}
                                style={{
                                    cursor: 'pointer',
                                    marginTop: '3px',
                                    width: '10px',
                                }}
                                onClick={handleDeleteAll}
                            />
                        </div>
                    </DeleteBtnDiv>
                </HeaderTextContainer>
            </HeaderGridContainer>
            {setsList &&
                setsList.map((item, index) => {
                    return (
                        <GridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                            key={index}
                        >
                            <ItemCardTextContainer
                                item
                                xs={11}
                                sm={6}
                                md={6}
                                lg={6}
                                xl={6}
                                mobile={11}
                                style={{ display: 'flex' }}
                            >
                                {!item.isBarCode && (
                                    <BoxView
                                        mr={'4px'}
                                        bgBorder={'1px solid #7ECA2A'}
                                        bgColor={'#7ECA2A80'}
                                        scrWidth={'21px'}
                                        mTop={'4px'}
                                        bRadius={'4px'}
                                    >
                                        <CustomLabel
                                            fSize={'10px!important'}
                                            letterSpacing={'0px !important'}
                                            pt={'2px!important'}
                                            fontFamily={'AvenirNextWorld Demi'}
                                            opacity={'1'}
                                            lineHeight={'20px'}
                                            color={'#140F4B'}
                                            label={'M'}
                                        />
                                    </BoxView>
                                )}

                                <SetNum
                                    display={'flex'}
                                    alignItems={'baseline'}
                                >
                                    {item.setNo}
                                    <BarCode>
                                        &nbsp;|&nbsp;{t('receiveSets.ReceiveSubmit.ReceivedSets.barcode')} {item.barcode}
                                    </BarCode>
                                </SetNum>
                            </ItemCardTextContainer>

                            <ItemCardTextContainer
                                item
                                xs={1}
                                sm={6}
                                md={6}
                                lg={6}
                                xl={6}
                                mobile={1}
                                style={{ textAlign: 'right' }}
                            >
                                <img
                                 id="receivesets-mobilesetslist-individual-delete-icon"
                                    src={DeleteLight}
                                    alt={'delete'}
                                    style={{
                                        cursor: 'pointer',
                                        border: '1px solid #f5f5f5',
                                        borderRadius: '6px',
                                        width: '25px',
                                        background:
                                            '0% 0% no-repeat padding-box padding-box rgb(255, 255, 255)',
                                        boxShadow:
                                            'rgb(0 0 0 / 16%) 0px 0px 2px',
                                    }}
                                    onClick={() =>
                                        handleIndividualItemDelete(index)
                                    }
                                />
                            </ItemCardTextContainer>
                            <BatchNumDiv>
                                <span
                                    style={{
                                        fontFamily: 'AvenirNextWorld Demi',
                                    }}
                                >
                                    {t('receiveSets.ReceiveSetsLoc.MobileSetsList.Batch')}
                                </span>
                                <BatchNum> {item.batchNo}</BatchNum>
                            </BatchNumDiv>
                            <SetDesc>
                                {item.description ? item.description : ''}
                            </SetDesc>
                            <CurrentLoc>{t('receiveSets.ReceiveSetsLoc.MobileSetsList.currentLocation')}</CurrentLoc>
                            <AccountName>
                                {item?.accountName}{' '}
                                <span style={{ fontStyle: 'italic' }}>
                                    {' '}
                                    {accountNumberZeroTrimmer(
                                        item?.accountCode
                                    )}
                                </span>
                            </AccountName>
                        </GridContainer>
                    );
                })}
        </MobileSetsDiv>
    );
}
